export var getNewsletterSource = function getNewsletterSource(pathname) {
  var source = pathname === '/black-friday' ? 'NEWSLETTER_BLACKFRIDAYPAGE' : 'NEWSLETTER';
  return source;
};